export const getProductRootTitle = (title?: string) => {
  if (!title) {
    return ''
  }
  const lastDashIndex = title.lastIndexOf('-')
  return lastDashIndex !== -1
    ? title.slice(0, lastDashIndex).trim()
    : `${title.trim()}`
}
